import { useCallback } from 'react';
import { LabelType, useCreateCustomLabelMutation } from 'graphql/types';
import { CustomLabel } from 'modules/timesheet-labels/labelSchema';

type CreateCustomLabelReturn = {
  loading: boolean;
  createCustomLabel: (labelName: string) => Promise<CustomLabel | undefined>;
};
export const useCreateCustomLabel = (
  onComplete?: () => void
): CreateCustomLabelReturn => {
  const [
    createCustomLabelMutation,
    { loading }
  ] = useCreateCustomLabelMutation();

  const createCustomLabel = useCallback(
    async (labelName: string) => {
      const result = await createCustomLabelMutation({
        variables: {
          input: {
            name: labelName,
            type: LabelType.Textselect
          }
        },
        refetchQueries: ['labels'],
        awaitRefetchQueries: true
      });
      onComplete?.();
      return result.data?.createCustomLabel.customLabel;
    },
    [createCustomLabelMutation, onComplete]
  );

  return { loading, createCustomLabel };
};
